export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
